import { render, staticRenderFns } from "./StudentApplicationDocuments.vue?vue&type=template&id=3893df01&"
import script from "./StudentApplicationDocuments.vue?vue&type=script&lang=js&"
export * from "./StudentApplicationDocuments.vue?vue&type=script&lang=js&"
import style0 from "./StudentApplicationDocuments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports